
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6ac01b44&scoped=true!stylus-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LDDiscussionTeacherCircle.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LDDiscussionTeacherCircle.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6ac01b44!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LDDiscussionTeacherCircle.vue"),
  /* scopeId */
  "data-v-6ac01b44",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/components/LDDiscussionTeacherCircle.vue
// module id = 1770
// module chunks = 61